import { RoomName, WS_ROOM_PREFIX } from "./webSocket.consts";

/**
 * @returns true if roomToTest===roomToLeave or roomToTest startsWith roomToLeave*
 */
export function isLeavingRoom(p: { roomToTest: RoomName, roomsToLeave: RoomName[] }): boolean {
    for (const roomToLeave of p.roomsToLeave) {
        if (roomToLeave === p.roomToTest) {
            // matches => remove
            return true;
        }
        if (roomToLeave.endsWith("*")) {
            if (p.roomToTest.startsWith(roomToLeave.slice(0, -1))) {
                // matches => remove
                return true;
            }
        }
    }
    return false;
}

/** 
 * returns the room name containing only the socket (can be used to exclude a socket from emit) 
 * * even if it returns directly socketUid you should use this function everywhere you want the socket room in order to ease debug and maintenance
 */
export function getSocketPersonalRoom(socketUid: string): RoomName {
    // by default socket.io creates a room for the socket => no need to have another room
    return socketUid;
}

/** returns the room name containing all the sockets of user */
export function getUserPersonalRoom(userUid: string): RoomName {
    // "!" => notify when a socket is opened or closed for user
    return "!USER_" + userUid;
}

/** Check all the prefixes on a room and return them */
export function getRoomPrefixes(room: RoomName): Set<WS_ROOM_PREFIX> {

    const addPrefix = (char: WS_ROOM_PREFIX): void => {
        previousPrefix = char;
        prefixes.add(char);
    };

    const prefixes = new Set<WS_ROOM_PREFIX>();
    let previousPrefix: WS_ROOM_PREFIX | undefined;

    // iterate through the char list of the string. 
    // we search a string composed of prefixes without any intersections between them
    // Ex: @!test will return @!, but !test@ will return !
    for (const char of room) {
        switch (char) {
            case WS_ROOM_PREFIX.AUTO_NOTIFICATION:
                addPrefix(char);
                break;
            case WS_ROOM_PREFIX.ROOM_MEMBER_NOTIFICATION:
                addPrefix(char);
                break;
            default:
                previousPrefix = undefined;
                break;
        }

        if (previousPrefix == null) {
            break;
        }
    }

    return prefixes;
}

/** Add the prefixes to the room name to format it correctly if prefixes were given */
export function generateRoomName(roomName: string, prefixes?: WS_ROOM_PREFIX[]): string {
    return prefixes != null ? `${prefixes.join()}${roomName}` : roomName;
}